module.exports = __webpack_public_path__ + "static/img/4.01271ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/4.jpg
// module id = BHK9
// module chunks = 16